<!-- /配置Logo  -->
<template>
  <div>
    <div style= "display:flex;padding: 30px">
     <span> 当前校徽：</span>
      <div v-if="schoolBadgeUrl" style="width: 400px; height: 200px">
        <img style="width: 100%; height: 100%; object-fit: contain;" :src="schoolBadgeUrl" alt="" />
      </div>
    </div>

    <div style="min-height:100%; display:flex;margin-top:30px">
      <span>修改校徽：</span>
      <div style="width: 155px;height:155px;overflow: hidden">
        <upload @imgUrlEmit="imgUrlEmit" :imgUrlArray="imgUrlArray" :num="num"></upload>
      </div>

    </div>

    <div style="text-align:center;">
      <el-button type="success" @click="save">保存</el-button>
    </div>
  </div>
</template>

<script>
import upload from "../../../components/upload/upload";
import {
  ConfigLoginList,
  ConfigLoginAdd,
  ConfigLoginEdit,
} from "../../../assets/js/network/network";
export default {
  name: "ConfigLogo",
  components: {
    upload,
  },
  props: {
    disposeData: Object,
  },
  data() {
    return {
      num:1,
      schoolBadgeUrlEmit:"",
      imgUrlArray: [],
      data: {},
      schoolBadgeUrl: "",
    };
  },
  mounted() {
    console.log(this.disposeData);
    this.getData(); //获取数据
  },
  // watch:{
  //  imgUrlArray(val){
  //    console.log(val)
  //  }
  // },
  methods: {
    getData() {
      let data = {
        organization_id: this.disposeData.organization_id,
        is_default: this.disposeData.is_default,
      };
      ConfigLoginList(data).then((res) => {
        if (res.code == 0) {
          if(res.ret){
            console.log(res);
          this.data = res.ret;
          this.schoolBadgeUrl = res.ret.login_school_badge;
          this.schoolBadgeUrlEmit = this.schoolBadgeUrl
            if(this.schoolBadgeUrl){
              this.imgUrlArray = this.schoolBadgeUrl.split(",");
            }

          // console.log(this.imgUrlArray)
          }

        }
      });
    },
    imgUrlEmit(v) {
      // console.log(v);
      this.schoolBadgeUrlEmit = v.length>0 ?v[0].url:""
    },
    save() {
      // console.log(this.schoolBadgeUrl);
      let data = {
        organization_id: this.disposeData.organization_id,
        is_default: this.disposeData.is_default,
      };
      ConfigLoginList(data).then((res1) => {
        if(res1.code == 0){
          this.data = res1.ret
          if (!!this.data.id) {
            // 修改
            let params = {
              id: this.data.id,
              login_school_badge: this.schoolBadgeUrlEmit,
            };
            ConfigLoginEdit(params).then((res) => {
              if (res.code == 0) {
                this.$message.success("修改成功");
                this.getData(); //获取数据
              }
            });
          } else {
            //添加
            this.disposeData.login_school_badge = this.schoolBadgeUrlEmit;
            ConfigLoginAdd(this.disposeData).then((res) => {
              if (res.code == 0) {
                this.$message.success("添加成功");
                this.getData(); //获取数据
              }
            });
          }
        }
      })

    },
  },
};
</script>

<style scoped>
img {
  object-fit: cover;
}
</style>
